import React from "react";
import logoLumos from "../../../assets/img/logo_lumos.png";

class Step2 extends React.Component {
  componentDidMount() {
    setTimeout(() => {
      this.enableInputs();
      this.startInputKeepAlive();
    }, 100);
  }

  componentDidUpdate() {
    setTimeout(() => {
      this.enableInputs();
    }, 0);
  }

  componentWillUnmount() {
    if (this.inputKeepAliveInterval) {
      clearInterval(this.inputKeepAliveInterval);
    }
  }

  startInputKeepAlive = () => {
    if (this.inputKeepAliveInterval) {
      clearInterval(this.inputKeepAliveInterval);
    }

    this.inputKeepAliveInterval = setInterval(() => {
      if (!this.containerRef) return;
      const inputs = this.containerRef.querySelectorAll('input[type="text"]');
      inputs.forEach((input) => {
        if (input.disabled) {
          input.disabled = false;
          input.removeAttribute("disabled");
        }
        input.style.pointerEvents = "auto";
        input.style.cursor = "text";
      });
    }, 100);
  };

  enableInputs = () => {
    if (!this.containerRef) return;
    const inputs = this.containerRef.querySelectorAll('input[type="text"]');
    inputs.forEach((input) => {
      input.disabled = false;
      input.readOnly = false;
      input.removeAttribute("disabled");
      input.removeAttribute("readonly");
      input.style.pointerEvents = "auto";
      input.style.cursor = "text";
      input.style.zIndex = "999999";
      input.style.position = "relative";
    });
  };

  scrollToButton = () => {
    setTimeout(() => {
      const button = this.containerRef?.querySelector('button[type="submit"]');
      if (button) {
        button.scrollIntoView({ behavior: "smooth", block: "end" });
      }
    }, 100);
  };

  handleInputChange = (field, value) => {
    this.props.onInputChange("step2", field, value);
    // Se mudar o campus, resetar a classe selecionada
    if (field === "campusOption") {
      this.props.onInputChange("step2", "classOption", "");
      // Aplicar lógica de desconto automático
      if (this.props.onCampusChange) {
        this.props.onCampusChange(value);
      }
      // Scroll para o botão quando o campus for selecionado
      this.scrollToButton();
    }
  };

  handleContinue = (e) => {
    e.preventDefault();
    // Validar que campus e classe foram selecionados
    if (this.props.data.campusOption && this.props.data.classOption) {
      this.props.onNext();
    }
  };

  render() {
    const { data, t } = this.props;
    const translate = t || ((key) => key);
    const isOnline = data.campusOption === "Online";
    const isInPerson = data.campusOption && data.campusOption !== "Online";

    return (
      <div
        className="step-container"
        ref={(ref) => {
          this.containerRef = ref;
        }}
        style={{ pointerEvents: "auto" }}
      >
        <div className="wizard-logo-container">
          <img src={logoLumos} alt="Lumos" className="wizard-logo" />
        </div>
        <div className="step-header">
          <h1 className="step-title">{translate("step2Title")}</h1>
          <p className="step-subtitle">{translate("step2Subtitle")}</p>
        </div>

        {/* Indicador de Progresso */}
        <div className="progress-indicator">
          {[1, 2, 3].map((step) => (
            <div
              key={step}
              className={`progress-bar ${step <= this.props.currentStep ? "active" : ""
                }`}
            />
          ))}
        </div>

        <form className="step-form" onSubmit={this.handleContinue}>
          <div className="form-group">
            <label className="form-label">{translate("campusOption")}</label>
            <div className="radio-group">
              <label className="radio-option">
                <input
                  type="radio"
                  name="campusOption"
                  value="Online"
                  checked={data.campusOption === "Online"}
                  onChange={(e) =>
                    this.handleInputChange("campusOption", e.target.value)
                  }
                  style={{
                    pointerEvents: "auto",
                    cursor: "pointer",
                    zIndex: 999999,
                    position: "relative",
                  }}
                />
                <span>Online</span>
              </label>
              <label className="radio-option">
                <input
                  type="radio"
                  name="campusOption"
                  value="Orem (In Person)"
                  checked={data.campusOption === "Orem (In Person)"}
                  onChange={(e) =>
                    this.handleInputChange("campusOption", e.target.value)
                  }
                  style={{
                    pointerEvents: "auto",
                    cursor: "pointer",
                    zIndex: 999999,
                    position: "relative",
                  }}
                />
                <span>Orem (In Person)</span>
              </label>
              <label className="radio-option">
                <input
                  type="radio"
                  name="campusOption"
                  value="Salt Lake City (In Person)"
                  checked={data.campusOption === "Salt Lake City (In Person)"}
                  onChange={(e) =>
                    this.handleInputChange("campusOption", e.target.value)
                  }
                  style={{
                    pointerEvents: "auto",
                    cursor: "pointer",
                    zIndex: 999999,
                    position: "relative",
                  }}
                />
                <span>Salt Lake City (In Person)</span>
              </label>
              <label className="radio-option">
                <input
                  type="radio"
                  name="campusOption"
                  value="Seattle (In Person)"
                  checked={data.campusOption === "Seattle (In Person)"}
                  onChange={(e) =>
                    this.handleInputChange("campusOption", e.target.value)
                  }
                  style={{
                    pointerEvents: "auto",
                    cursor: "pointer",
                    zIndex: 999999,
                    position: "relative",
                  }}
                />
                <span>Seattle (In Person)</span>
              </label>
            </div>
          </div>

          {data.campusOption && (
            <div className="form-group">
              <label className="form-label">{translate("classes")}</label>
              <div className="radio-group">
                {isOnline ? (
                  <label className="radio-option">
                    <input
                      type="radio"
                      name="classOption"
                      value="Tuesday and Thursday | Evening | 6:30 PM to 8:00 PM"
                      checked={
                        data.classOption ===
                        "Tuesday and Thursday | Evening | 6:30 PM to 8:00 PM"
                      }
                      onChange={(e) =>
                        this.handleInputChange("classOption", e.target.value)
                      }
                      style={{
                        pointerEvents: "auto",
                        cursor: "pointer",
                        zIndex: 999999,
                        position: "relative",
                      }}
                    />
                    <span>
                      Tuesday and Thursday | Evening | 6:30 PM to 8:00 PM
                      (Mountain Time)
                    </span>
                  </label>
                ) : isInPerson ? (
                  <label className="radio-option">
                    <input
                      type="radio"
                      name="classOption"
                      value="Saturday | Morning | 9 AM to 12 PM"
                      checked={
                        data.classOption ===
                        "Saturday | Morning | 9 AM to 12 PM"
                      }
                      onChange={(e) =>
                        this.handleInputChange("classOption", e.target.value)
                      }
                      style={{
                        pointerEvents: "auto",
                        cursor: "pointer",
                        zIndex: 999999,
                        position: "relative",
                      }}
                    />
                    <span>
                      Saturday | Morning | 9 AM to 12 PM (Mountain Time)
                    </span>
                  </label>
                ) : null}
              </div>
            </div>
          )}

          <div className="button-group">
            <button
              type="button"
              className="prev-button"
              onClick={this.props.onPrev}
            >
              {translate("back")}
            </button>
            <button
              type="submit"
              className="continue-button"
              disabled={!data.campusOption || !data.classOption}
            >
              {translate("continue")}
            </button>
          </div>
        </form>
      </div>
    );
  }
}

export default Step2;
